/**
 * Laesst die Akzentmarken der Ueberschriften einmalig einlaufen, sobald sie in
 * den Viewport kommen (Optik: base/_typography.scss).
 *
 * Die Marken sind ohne JavaScript vollstaendig sichtbar. Erst dieser Controller
 * setzt "js-reveal" am <html> und schaltet damit den Startzustand ein – so
 * bleibt die Seite ohne JS und bei abgeschalteten Animationen benutzbar.
 */
export default class HeadingRevealController {
  private static readonly ROOT_CLASS = 'js-reveal';
  private static readonly REVEALED_CLASS = 'is-revealed';
  private static readonly SELECTOR = 'h1, .h1';

  /**
   * Traegt keine Marke, muss also auch nicht beobachtet werden: ein h1, das
   * bewusst kleiner ausgezeichnet ist (<h1 class="h2">), und Ueberschriften, die
   * nur ein Bedienelement umschliessen (Accordion).
   */
  private static readonly WITHOUT_MARK = '.h2, .h3, .h4, .h5, .h6, .accordion-header';

  private _observer?: IntersectionObserver;

  constructor() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Bei verdeckter Seite (Hintergrund-Tab) liefert der IntersectionObserver
    // keine Callbacks. Dann gar nicht erst verstecken, sonst bleiben die Marken
    // unsichtbar, bis der Tab in den Vordergrund kommt.
    const hidden = document.visibilityState === 'hidden';

    if (reduceMotion || hidden || !('IntersectionObserver' in window)) {
      return;
    }

    document.documentElement.classList.add(HeadingRevealController.ROOT_CLASS);

    this._observer = new IntersectionObserver(
      (entries) => this._onIntersect(entries),
      { threshold: 0.2 },
    );

    document
      .querySelectorAll(HeadingRevealController.SELECTOR)
      .forEach((heading: Element) => {
        if (heading.matches(HeadingRevealController.WITHOUT_MARK)) {
          return;
        }

        this._observer?.observe(heading);
      });
  }

  private _onIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.classList.add(HeadingRevealController.REVEALED_CLASS);
      this._observer?.unobserve(entry.target);
    });
  }
}
